<template>
  <div
    class="ns-checkbox"
    :class="{ 'nsc-enabled': enabled, 'nsc-disabled': !enabled }"
    :style="{ display: inline ? 'inline-block' : '' }"
  >
    <label class="nsc-container" :style="{ 'line-height': size + 'px' }">
      <span
        class="nsc-input"
        :style="{ width: size + 'px', height: size + 'px' }"
      >
        <input v-model="model" type="checkbox" :disabled="!enabled" />
        <span class="nsc-icon">
          <NsIcon
            class="nsc-icon-check"
            :icon-name="iconName"
            color="#FFFFFF"
          />
        </span>
      </span>
      <span class="nsc-label">
        <slot name="label">
          {{ label }}
        </slot>
      </span>
    </label>
    <div
      v-if="$slots['additional'] || $scopedSlots['additional']"
      class="nsc-additional"
      :style="{ 'margin-left': size + 'px' }"
    >
      <slot name="additional" />
    </div>
  </div>
</template>

<script>
/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { NsIcon } from '@nuskin/ns-icon';

export default {
  name: 'NsCheckbox',
  components: {
    NsIcon,
  },
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
    iconName: {
      type: String,
      default: 'icon-checkmark',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 24,
    },
    /**
     * Indicates if the checkbox is checked.
     */
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use '~@nuskin/ns-core-styles/src/scss/colors';
@use "~@nuskin/ns-core-styles/src/scss/_typographyVariables.scss" as types;

$background-color: #ffffff;
$border-color: map.get(colors.$baseColors, blackhole);
$border-shells: map.get(colors.$baseColors, shells);

.ns-checkbox {
  .nsc-container {
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    margin: 0;
    padding: 0;
    line-height: 22px;
    font-family: map.get(types.$typography, 'font-family-primary');
  }

  input[type='checkbox'] {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 0;
    height: 0;
  }

  .nsc-input {
    user-select: none;
    opacity: 0.25;
    display: inline-block;
    flex-grow: 0;
    flex-shrink: 0;
    overflow: visible;
    position: relative;
    margin-right: 0.5em;

    &:focus-within {
      box-shadow: 0 0 5px 2px rgba($border-shells, 0.2);
    }
  }

  .nsc-icon {
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $background-color;
    border-color: $border-color;
    border-style: solid;
    border-width: 1px;
    border-radius: 2px;

    .nsc-icon-check {
      width: 83.33%;
      height: 83.33%;
    }
  }

  &.nsc-enabled {
    .nsc-input {
      opacity: 1;
    }

    input[type='checkbox']:checked ~ .nsc-icon {
      background-color: $border-color;
    }
  }

  &.nsc-disabled {
    input[type='checkbox']:checked ~ .nsc-icon {
      background-color: map.get(colors.$baseColors, dryink);
    }
  }
}

.nsc-additional {
  padding-left: 0.5em;
}
</style>
